module.exports = __webpack_public_path__ + "media/images/design/images/btn_pickup-55e631efc356d3b62aa39455be4934c0.png";